import React from 'react';

const TripHailingProcedure = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Customer Trip Hailing Procedure for XGO Life App</h1>
      <p className="mb-4">
        By following this procedure, customers can efficiently hail trips using the Xgo Life App, ensuring a smooth and enjoyable travel experience.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Account Setup</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Download the App:</strong> Install the Xgo Life App from the App Store or Google Play Store.</li>
        <li><strong>Create an Account:</strong> Sign up by providing your email address, phone number, and creating a password. Verify your account through the confirmation link sent to your email.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Setting Your Location</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Enable Location Services:</strong> Allow the app to access your location for accurate pickup and drop-off points.</li>
        <li><strong>Set Pickup Location:</strong> The app will automatically detect your current location. You can adjust the pickup point by dragging the pin on the map or entering a specific address.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Choosing Your Destination</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Enter Destination:</strong> Type in your desired drop-off location in the designated field.</li>
        <li><strong>View Route Options:</strong> The app may provide different route options based on distance and estimated time of arrival.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Selecting a Ride Type</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Choose Vehicle Option:</strong> Select the type of ride that suits your needs (e.g., economy, premium, shared ride). The app will display estimated fares for each option.</li>
        <li><strong>Review Vehicle Details:</strong> Check the details of the vehicle, such as the make, model, and license plate number.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Requesting the Trip</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Confirm Ride Details:</strong> Review the pickup location, destination, and ride type to ensure everything is correct.</li>
        <li><strong>Request Ride:</strong> Tap the "Request Ride" button to book your trip. The app will search for available drivers nearby.</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Waiting for Driver Confirmation</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Driver Match:</strong> Once a driver is assigned, you will receive a notification with the driver’s details, including name, vehicle information, and estimated time of arrival (ETA).</li>
        <li><strong>Track Driver:</strong> You can track the driver’s location in real-time on the map within the app.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. During the Ride</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Safety Features:</strong> Share your trip details with a friend or family member for added safety. The app may have an option to share your live location.</li>
        <li><strong>Communicate with Driver:</strong> If necessary, use the in-app messaging or calling feature to communicate with your driver regarding directions or any changes.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. Completing the Trip</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Arrival Notification:</strong> You’ll receive a notification when you arrive at your destination.</li>
        <li><strong>Exit the Vehicle:</strong> Ensure you have all your belongings before exiting the vehicle.</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Payment Process</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Automatic Payment:</strong> Payment will be processed automatically through your selected payment method in the app.</li>
        <li><strong>Review Fare:</strong> Check the fare breakdown, including any surcharges or discounts applied.</li>
      </ul>

      <h2 className="text-2xl font-semibold">10. Rating and Feedback</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Rate Your Experience:</strong> After the trip, rate your driver and provide feedback on your experience to help improve service quality.</li>
        <li><strong>Report Issues:</strong> If you encounter any issues during the trip, you can report them through the app’s support feature.</li>
      </ul>

      <h2 className="text-2xl font-semibold">11. Customer Support</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Access Help Center:</strong> If you have questions or need assistance, visit the Help Center in the app for FAQs or contact customer support directly.</li>
      </ul>
    </div>
  );
};

export default TripHailingProcedure;